import React, { useEffect } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import NavbarACG from './components/layout/NavbarACG';
import Landing from './components/layout/Landing';
import Login from './components/auth/Login';
import Alert from './components/layout/Alert';
import Dashboard from './components/dashboard/Dashboard';
import Userlist from './components/users/UserList';
import UserDetail from './components/users/UserDetail';
import UserEdit from './components/users/UserEdit';
import NotFound from './components/layout/NotFound';
import PrivateRoute from './components/routing/PrivateRoute';
import AffichageLog from './components/log/AffichageLog';
import CotationDetail from './components/cotation/CotationDetail';
import CotationList from './components/cotation/CotationList';
import CotationCreate from './components/cotation/CotationCreate';
import RechercheCotation from './components/cotation/RechercheCotation';
import FaqCodegen from './components/faq/FaqCodegen';
// import ActivateUser from './components/activation/ActivateUser';
import VerifyEmailResetPassword from './components/activation/VerifyEmailResetPassword';
import ResetPassword from './components/activation/ResetPassword';
import CGUacg from './components/activation/CGUacg';
import { LOGOUT } from './actions/types';

// Redux
import { Provider } from 'react-redux';
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap'; // obligatoire pour faire fonctionner les popper, modal et dropdown
import './App.css';

const App = () => {
  useEffect(() => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    store.dispatch(loadUser());
    // log user out from all tabs if they log out in one tab
    window.addEventListener('storage', () => {
      if (!localStorage.token) store.dispatch({ type: LOGOUT });
    });
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <NavbarACG />
        <Alert />
        {/* <section className="container"> */}
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/activation/:id/:token" element={<ResetPassword />} />
          <Route path="/verifyemail" element={<VerifyEmailResetPassword />} />
          <Route path="/resetpassword/:id/:token" element={<ResetPassword />} />
          <Route path="/cgu" element={<CGUacg />} />
          <Route path="/faq" element={<FaqCodegen />} />
          <Route
            path="/users"
            element={<PrivateRoute component={Userlist} />}
          />
          <Route
            path="/user/:id"
            element={<PrivateRoute component={UserDetail} />}
          />
          <Route
            path="/dashboard"
            element={<PrivateRoute component={Dashboard} />}
          />
          <Route
            path="/edit-user/:id"
            element={<PrivateRoute component={UserEdit} />}
          />
          <Route
            path="/create-user"
            element={<PrivateRoute component={UserEdit} />}
          />
          <Route
            path="/cotation/:id"
            element={<PrivateRoute component={CotationDetail} />}
          />
          <Route
            path="/recherchecotations"
            element={<PrivateRoute component={RechercheCotation} />}
          />
          <Route
            path="/cotations/:marque/:modele"
            element={<PrivateRoute component={CotationList} />}
          />
          <Route
            path="/create-cotation"
            element={<PrivateRoute component={CotationCreate} />}
          />
          <Route
            path="/edit-cotation/:id"
            element={<PrivateRoute component={CotationCreate} />}
          />
          <Route
            path="/eventlog"
            element={<PrivateRoute component={AffichageLog} />}
          />
          <Route path="/*" element={<NotFound />} />
        </Routes>
        {/* </section> */}
      </Router>
    </Provider>
  );
};

export default App;
